import { render, staticRenderFns } from "./TemplateListGallery.vue?vue&type=template&id=476a8bb6&scoped=true&"
import script from "./TemplateListGallery.vue?vue&type=script&lang=js&"
export * from "./TemplateListGallery.vue?vue&type=script&lang=js&"
import style0 from "./TemplateListGallery.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TemplateListGallery.vue?vue&type=style&index=1&id=476a8bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a8bb6",
  null
  
)

export default component.exports